module.exports = __webpack_public_path__ + "static/img/zfb.782b5cce.png";